import type { ReactNode } from 'react';
import Breadcrumb, { type Crumb } from '@/components/base/Breadcrumb';

interface PageHeaderProps {
  title: string;
  description: string;
  crumbs: Crumb[];
  icon?: string;
  children?: ReactNode;
}

export default function PageHeader({ title, description, crumbs, icon, children }: PageHeaderProps) {
  return (
    <section className="border-b border-background-200/70 bg-background-50">
      <div className="mx-auto w-full max-w-[1280px] px-4 py-7 md:px-6 md:py-9">
        <div className="mb-4">
          <Breadcrumb items={crumbs} />
        </div>
        <div className="flex items-start gap-4">
          {icon && (
            <span className="hidden h-12 w-12 flex-shrink-0 items-center justify-center rounded-lg bg-primary-500 text-background-50 sm:flex dark:text-foreground-950">
              <i className={`${icon} text-2xl`}></i>
            </span>
          )}
          <div className="min-w-0 flex-1">
            <h1 className="font-heading text-2xl font-bold text-foreground-950 md:text-3xl">{title}</h1>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600 md:text-base">{description}</p>
          </div>
        </div>
        {children}
      </div>
    </section>
  );
}